var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CautionTemplate",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.hasServerError,
          expression: "hasServerError",
        },
      ],
      staticClass: "cautionArea",
    },
    [
      _vm.errorType === _vm.REGISTER_ERROR_TYPES.TOKEN_CHECK_ERROR
        ? _c("p", { staticClass: "cautionText" }, [
            _vm._v("\n    不正な操作が発生しました。"),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "cautionLink",
                attrs: { href: _vm.selfLocationPath },
              },
              [_vm._v("こちら")]
            ),
            _vm._v("からやり直してください。\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorType === _vm.REGISTER_ERROR_TYPES.SESSION_EXPIRE
        ? _c("p", { staticClass: "cautionText" }, [
            _vm._v(
              "\n    しばらくの間操作がなかったため、セッション切れとなりました。"
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "cautionLink",
                attrs: { href: _vm.selfLocationPath },
              },
              [_vm._v("こちら")]
            ),
            _vm._v("からやり直してください。\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorType === _vm.REGISTER_ERROR_TYPES.DUPLICATE_REGISTER
        ? _c(
            "p",
            { staticClass: "cautionText" },
            [
              _vm.notNeedToLoginButton
                ? [
                    _vm._v("\n      すでに登録されているメールアドレスです。"),
                    _c("br", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isSp,
                          expression: "isSp",
                        },
                      ],
                    }),
                    _vm._v("別のメールアドレスを入力してください。\n    "),
                  ]
                : [
                    _vm._v("\n      すでに登録済みのメールアドレスです。"),
                    _c("br", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isSp,
                          expression: "isSp",
                        },
                      ],
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "cautionLink",
                        attrs: {
                          href:
                            "/" + _vm.urlPrefix + "/quipMember/auth/signIn/",
                        },
                      },
                      [_vm._v("こちら")]
                    ),
                    _vm._v("からログインしてください。\n    "),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.errorType === _vm.REGISTER_ERROR_TYPES.SYSTEM_ERROR
        ? _c("p", { staticClass: "cautionText" }, [
            _vm._v("\n    予期せぬエラーが発生しました。"),
            _c(
              "a",
              {
                staticClass: "cautionLink",
                attrs: {
                  href: "/" + _vm.urlPrefix + "/quipMember/register/infoInput/",
                },
              },
              [_vm._v("こちら")]
            ),
            _vm._v("からやり直してください。\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.serverErrorList, function (message) {
        return _c("p", { key: message, staticClass: "cautionText" }, [
          _vm._v("\n    " + _vm._s(message) + "\n  "),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }